"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const tf = require("@tensorflow/tfjs");
const facemesh = require("@tensorflow-models/face-landmarks-detection");
require("@tensorflow/tfjs-backend-webgl");
require("@tensorflow/tfjs-backend-cpu");
// import { setWasmPaths } from '@tensorflow/tfjs-backend-wasm';
// import wasmPath from '../../node_modules/@tensorflow/tfjs-backend-wasm/dist/tf-backend-wasm.wasm';
class Detector {
    constructor(backend) {
        this._backend = backend;
    }
    initializationDetector(backend = 'webgl') {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                tf.setBackend(backend);
                this._faceMeshModel = yield facemesh.load(facemesh.SupportedPackages.mediapipeFacemesh, {
                    maxFaces: 1,
                });
                return {
                    type: 'success',
                    message: 'ok',
                };
            }
            catch (error) {
                return {
                    type: 'error',
                    message: error,
                };
            }
        });
    }
    detect(input) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this._faceMeshModel)
                    throw new Error('Model is undefined!');
                const predictions = yield this._faceMeshModel.estimateFaces({ input });
                return predictions;
            }
            catch (error) {
                console.log(error);
                return error;
            }
        });
    }
    get backend() {
        return this._backend;
    }
    set backend(backend) {
        this._backend = backend;
        tf.setBackend(backend);
    }
}
exports.default = Detector;
